import InternalTransferConfirmation from './InternalTransferConfirmation';

export default InternalTransferConfirmation;
